import React, { useContext, useState } from 'react'
import { Button } from 'react-bootstrap'
import { isCourseSignUpOpen, regularSpotOpen, reserveSpotOpen, SignUpToCourse, validSignUpDate } from '../../../../components/exl/CourseHelperFunctions';
import { getLastDayToCancelBooking, RemoveBooking } from '../../../../components/exl/BookingHelperFunctions';
import { DataContext as SharedDataContext } from '../../../../store';
import moment from 'moment';
import { CheckBookingAvailability } from '../../../../components/exl/requests/BookingRequests';
import { DataContext as CrmDataContext } from '../../../../stores/crm-store';
import SpinLoader from '../../../../components/crm/shared/field_inputs/shared/SpinLoader';
import OnHoverTooltip from '../../../../components/tables/shared/OnHoverTooltip';
import { disabledCourseSignUpDescriptions } from '../../../../components/exl/shared/translations';
import { useTranslation } from 'react-i18next';
import { CONFLICTING_BOOKING_ERROR, COURSE_PRIM_ACT_BUTTON_ENROLL_ME, COURSE_PRIM_ACT_BUTTON_ENROLL_ME_AS_RESERVE, COURSE_PRIM_ACT_BUTTON_ENROLLMENT_CLOSED, COURSE_PRIM_ACT_BUTTON_UNENROLL_ME } from '../../../../i18n/keyConstants';

const getRegisterButtonText = (course, courseUser, t) =>
  courseUser.isRegistered ? t(COURSE_PRIM_ACT_BUTTON_UNENROLL_ME)
    : regularSpotOpen(course) ? t(COURSE_PRIM_ACT_BUTTON_ENROLL_ME)
      : reserveSpotOpen(course) ? t(COURSE_PRIM_ACT_BUTTON_ENROLL_ME_AS_RESERVE)
        : t(COURSE_PRIM_ACT_BUTTON_ENROLLMENT_CLOSED)

const getRegisterButtonColor = (disabled, courseUser) =>
  disabled ? 'secondary'
    : courseUser.isRegistered ? 'danger'
      : 'success'

export default function PrimaryActionButton({ course, courseUser, refreshCourseData }) {
    const { dispatch: sharedDispatch } = useContext(SharedDataContext);
    const { dispatch: dispatch } = useContext(CrmDataContext);
    const { t } = useTranslation(['coursePrimaryActionButton', 'errorMessages']);
    const [saving, setSaving] = useState(false);

  const disableSignUp = (!isCourseSignUpOpen(course) && !courseUser.isRegistered) || courseUser.teacherPermission || courseUser.lectureTeacherPermission;
  const disableCancelBooking = moment().format('YYYY-MM-DD') > getLastDayToCancelBooking(course);
  const disabled = disableSignUp || disableCancelBooking;

  const getToolTipMessage = () => {
      if(course.lectures.length === 0)
          return t(disabledCourseSignUpDescriptions.courseNoLectures);
      else if (!validSignUpDate(course))
          return t(disabledCourseSignUpDescriptions.courseSignupClosed);
      else if (!regularSpotOpen(course) && !reserveSpotOpen(course))
          return t(disabledCourseSignUpDescriptions.noSpotsOpen);
      else if (disableCancelBooking)
          return t(disabledCourseSignUpDescriptions.courseCancelClosed);
      else if (courseUser.teacherPermission)
          return t(disabledCourseSignUpDescriptions.teacher);
  }

  const handleOnClick = async () => {
      if (courseUser.isRegistered) {
        setSaving(true);
        await RemoveBooking(courseUser?.booking, sharedDispatch, refreshCourseData);
        setSaving(false);
    } else {
        var res = await CheckBookingAvailability(course.id, courseUser.coaEmpId);
        if (res.available === true) {
            setSaving(true);
            await SignUpToCourse(course.id, sharedDispatch, refreshCourseData, t);

            setSaving(false);
        } else {
            dispatch({
                type: 'SHOW_GENERIC_EXL_ERROR_TOAST',
                payload: t(CONFLICTING_BOOKING_ERROR, {ns: 'errorMessages'})
            })
        }
    }
  }

  return (
      <div className='exl-action-buttons-container'>
          {(courseUser.teacherPermission && !courseUser.editPermission)?
            null
            :
            <>
            {disabled ?
            <OnHoverTooltip
              labelClassNames='d-flex margin-none'
              tooltipType='dark'
              tooltipPlace='left'
              tooltipEffect='solid'
              >
                
                <Button
                  // disabled={disabled}
                  variant={getRegisterButtonColor(disabled, courseUser)}
                  className={`btn btn-success save-button ${disabled ? 'disabled' : ''}`}
                  style={{ pointerEvents: 'none' }}
                  >
                  <div className={saving ? 'invisible' : ''}>{getRegisterButtonText(course, courseUser, t)}</div>
                  <SpinLoader isLoading={saving} size={'20px'} />
                </Button>

                <span className='d-flex my-auto' style={{ width: 125 }}>{getToolTipMessage()}</span>
            </OnHoverTooltip>
            :
            <Button
              variant={getRegisterButtonColor(disabled, courseUser)}
              onClick={handleOnClick}
              className='btn btn-success save-button exl-button'>
              <div className={saving ? 'invisible' : ''}>{getRegisterButtonText(course, courseUser, t)}</div>
              <SpinLoader isLoading={saving} size={'20px'} />
            </Button>
            }
            </>
          }
          
    </div>
  )
}
